import React, { useEffect, useState } from "react";
import { EditIconButton } from "components/DatatablesActionIcons";
import summaryIcon from "assets/images/summary.png";
import "./approved-proof-order-summary.css";

export type ApprovedProofOrderSummaryProps = {
  orderSummary?: string;
  saving?: boolean;
  onSave: (text: string) => Promise<void>;
};

export default function ApprovedProofOrderSummary({
  orderSummary = "",
  saving = false,
  onSave,
}: ApprovedProofOrderSummaryProps) {
  const saved = String(orderSummary || "").trim();
  const [mode, setMode] = useState<"view" | "edit">(saved ? "view" : "edit");
  const [draft, setDraft] = useState(saved);

  useEffect(() => {
    const next = String(orderSummary || "").trim();
    setDraft(next);
    setMode(next ? "view" : "edit");
  }, [orderSummary]);

  const handleSave = async () => {
    const text = draft.trim();
    if (!text) return;
    await onSave(text);
    setMode("view");
  };

  const handleCancel = () => {
    setDraft(saved);
    setMode(saved ? "view" : "edit");
  };

  return (
    <div className="pq-proof-order-summary">
      <div className="pq-proof-order-summary-head">
        <div className="pq-proof-order-summary-title">
          <img src={summaryIcon} alt="" className="pq-proof-order-summary-icon" aria-hidden />
          <span>SUMMARY</span>
        </div>
        <span className="pq-proof-order-summary-hint">Internal notes only</span>
      </div>

      {mode === "view" && saved ? (
        <div className="pq-proof-order-summary-view-wrap">
          <div className="pq-proof-order-summary-view">
            <p className="pq-proof-order-summary-text">{saved}</p>
            <EditIconButton
              type="button"
              className="icon-square pq-proof-order-summary-edit-btn"
              onClick={() => setMode("edit")}
              title="Edit note"
              aria-label="Edit summary note"
            />
          </div>
        </div>
      ) : (
        <div className="pq-proof-order-summary-edit-wrap">
          <textarea
            className="pq-proof-order-summary-textarea"
            placeholder="Add a summary note about this conversation and approval…"
            value={draft}
            onChange={(e) => setDraft(e.target.value)}
            rows={4}
            disabled={saving}
          />
          <div className="pq-proof-order-summary-foot">
            {/* <span className="pq-proof-order-summary-foot-hint">Visible to team members only</span> */}
            <div className="pq-proof-order-summary-actions">
              {saved ? (
                <button
                  type="button"
                  className="pq-proof-order-summary-cancel-btn"
                  onClick={handleCancel}
                  disabled={saving}
                >
                  Cancel
                </button>
              ) : null}
              <button
                type="button"
                className="pq-proof-order-summary-save-btn"
                onClick={() => void handleSave()}
                disabled={saving || !draft.trim()}
              >
                {saving ? "Saving…" : "Save Note"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
